import client from './client';

export type ReviewStatus = 'not_started' | 'in_progress' | 'in_review' | 'closed';

export const REVIEW_STATUS_LABELS_HE: Record<ReviewStatus, string> = {
  not_started: 'לא התחיל',
  in_progress: 'בעבודה',
  in_review:   'בסקירה',
  closed:      'סגור',
};

/** Color tokens for each status. Tuned so 'closed' reads complete
 * (green), 'in_review' is amber (waiting), 'in_progress' blue (active),
 * and 'not_started' grey (idle). */
export const REVIEW_STATUS_COLORS: Record<ReviewStatus, { bg: string; fg: string }> = {
  not_started: { bg: '#F1F5F9', fg: '#475569' },
  in_progress: { bg: '#DBEAFE', fg: '#1E40AF' },
  in_review:   { bg: '#FEF3C7', fg: '#92400E' },
  closed:      { bg: '#DCFCE7', fg: '#166534' },
};

export interface CompanyReviewStatus {
  year: number;
  status: ReviewStatus;
  assigned_to: string | null;
  updated_at: string | null;
  updated_by: string | null;
  updated_by_name: string | null;
}

export interface CompanyStatusSummary {
  company_id: string;
  year: number | null;
  status: ReviewStatus | null;
  updated_at: string | null;
}

export async function listCompanyStatuses(): Promise<CompanyReviewStatus[]> {
  const r = await client.get<CompanyReviewStatus[]>('/company-status/review-status');
  return r.data;
}

export async function upsertCompanyStatus(body: {
  year: number;
  status: ReviewStatus;
  assigned_to?: string | null;
}): Promise<CompanyReviewStatus> {
  const r = await client.put<CompanyReviewStatus>('/company-status/review-status', body);
  return r.data;
}

export async function summaryAllStatuses(year?: number): Promise<CompanyStatusSummary[]> {
  const r = await client.get<CompanyStatusSummary[]>(
    '/company-status/review-status/summary-all',
    { params: year ? { year } : undefined },
  );
  return r.data;
}
